<template>
  <div class="mb-6">
    <input v-model="locale" class="p-2 mb-2 w-full rounded" readonly />
    <input v-model="key" class="p-2 mb-2 w-full rounded" readonly />
    <textarea
      v-model="translationValue"
      placeholder="Translation Value"
      class="border p-2 w-full h-32 rounded"
      :disabled="loading"
      :placeholder="loading ? 'Loading...' : ''"
    />
  </div>

  <div class="w-full flex gap-4">
    <button
      type="button"
      @click="cancel"
      class="px-3 py-1 text-sm font-medium text-gray-900 bg-white border border-gray-300 focus:outline-none hover:bg-gray-100 focus:ring-4 focus:ring-gray-100 rounded-lg"
    >
      Cancel
    </button>
    <button
      type="button"
      @click="save"
      class="flex-1 px-3 py-1 text-sm font-medium text-white bg-blue-700 hover:bg-blue-800 focus:outline-none focus:ring-4 focus:ring-blue-300 rounded-lg text-center"
      :disabled="loading"
    >
      Save
    </button>
  </div>
</template>

<script setup>
import { ref } from "vue";

const loading = ref(true);
const locale = ref("");
const translationValue = ref("");
const key = ref("");

window.addEventListener("aft:edit-translation", ({ detail }) => {
  loading.value = true;
  locale.value = detail.locale;
  key.value = detail.key;
  translationValue.value = "";

  fetch(
    `/api/admin/translations?locale=${encodeURIComponent(
      detail.locale,
    )}&key=${encodeURIComponent(detail.key)}`,
  )
    .then((response) => response.json())
    .then((data) => {
      translationValue.value = data.value || "";
      loading.value = false;
    });
});

const cancel = () => {
  const event = new CustomEvent("aft:close-translation-form");
  window.dispatchEvent(event);
};

const save = () => {
  loading.value = true;

  const formData = new FormData();
  formData.append("locale", locale.value);
  formData.append("key", key.value);
  formData.append("value", translationValue.value);

  fetch("/api/admin/translations", {
    method: "PUT",
    headers: {
      "X-CSRF-Token": document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute("content"),
    },
    body: formData,
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then((data) => {
      alert("Translation saved successfully.");
    });
};
</script>
